export const PROMOTION_DEFAULT_PAGE = 1;
export const PROMOTION_DEFAULT_PAGE_SIZE = 12;

export const PROMOTION_ENDPOINTS = {
  // 1. List Promotions (Customer / General View)
  listGeneral: "/promotion/",

  // 2. List Promotions with Filters / Preferred (Partner View)
  listPreferred: "/promotion/list/preferred",

  // 3. List My / Specific Partner's Promotions
  listMyPreferred: "/promotion/list/my/preferred",

  // 4. Get Promotion Details by ID
  details: (id) => `/promotion/${id}`,

  // 5. Add / Create Promotion
  create: "/promotion/add",

  // 5b. Edit Promotion
  edit: "/promotion/edit",

  // 6. Delete Promotion
  remove: (id) => `/promotion/delete/${id}`,

  // 7. Upload Promotion Media (Images / Videos)
  uploadMedia: "/all/upload/files/images",

  // 8. Upload Promotion Documents / Attachments
  uploadAttachments: "/all/upload/files/attachments",

  // 9. AI Generate Promotion Description
  aiGenerateDescription: "/api/v1/ai/generate-description",

  // 10. Get Comments on a Promotion
  comments: (userId, promotionId) =>
    `/property/requestPromotionComments/${userId}/${promotionId}`,

  // 11. Add Comment / Reply to a Promotion
  addComment: "/property/addRequestPromotionComment",

  // 12. Edit Promotion Comment
  editComment: "/property/editRequestPromotionComment",

  // 13. Delete Promotion Comment
  deleteComment: (commentId) =>
    `/property/deleteRequestPromotionComment/${commentId}`,

  // Helper metadata endpoints
  states: (countryId = 1) => `/admin/states/${countryId}`,
  cities: (stateId) => `/admin/cities/${stateId}`,
  propertyTypes: "/all/property/types",
};

export const PROMOTION_TABS = {
  ALL: "all",
  PREFERRED: "preferred",
  MY: "my",
};
